import { render, staticRenderFns } from "./data-boxes.vue?vue&type=template&id=3e498aa3&scoped=true"
import script from "./data-boxes.vue?vue&type=script&lang=js"
export * from "./data-boxes.vue?vue&type=script&lang=js"
import style0 from "./data-boxes.vue?vue&type=style&index=0&id=3e498aa3&prod&lang=scss&scoped=true"
import style1 from "./data-boxes.vue?vue&type=style&index=1&id=3e498aa3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e498aa3",
  null
  
)

export default component.exports